// Rodolfo Rivas
// 2017
//*************************************************************//
//                                                             //
//    ╔═╗┌─┐┌┬┐┌─┐┌─┐┌┐┌┌─┐┌┐┌┌┬┐┌─┐  ┬ ┬┌─┐┬ ┬┌─┐┬─┐┬┌─┐      //
//    ║  │ ││││├─┘│ ││││├┤ │││ │ ├┤   │ │└─┐│ │├─┤├┬┘││ │      //
//    ╚═╝└─┘┴ ┴┴  └─┘┘└┘└─┘┘└┘ ┴ └─┘  └─┘└─┘└─┘┴ ┴┴└─┴└─┘      //
//                                                             //
//*************************************************************//


import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {BsDatepickerConfig, BsLocaleService} from 'ngx-bootstrap/datepicker';
import {LogEmisorService} from "../../../transaccion/logEmisor/recursos/servicios/logEmisor.service";
import {UtilConfig} from "../../../../../autenticacion/servicios/UtilConfig";
import {LogEmisor} from "../../../transaccion/logEmisor/recursos/modelo/LogEmisor";
// ITEM QUE SE DEBE MODIFICAR PARA LOS CRUD
declare const $: any;

declare var swal: any;
declare let d3: any;

@Component({
    selector: 'app-indicadores',
    templateUrl: './view/indicadores.component.html',
    styleUrls: ['./css/indicadores.component.css'],
    providers: [LogEmisorService]
})

export class IndicadoresComponent implements OnInit {

//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─

    // ITEM DEL CRUD
    origenCRUD = "Transacciones";
    // variables de pantalla
    emisor: any = {};
    emisores: any[];
    empresaAdministradora = false;
    mensaje;
    loading = false;
    noHayResultados = false;
    es;
    cargandoConsulta = false;
    cargandoList = false;

    // VARIABLES DE SEGURIDAD
    authorities = {
        ROLE_LOG_LISTAR: false,
        ROLE_LOG_CONSULTAR: false,
        ROLE_LOG_REGISTRAR: false,
        ROLE_LOG_MODIFICAR: false,
        ROLE_LOG_ELIMINAR: false,
        ROLE_LOG_ACTIVAR: false,
    };
    //variables modelo
    graficaGeneral: any;
    graficaModulosFactura: any;
    graficaModulosBoleta: any;
    graficaModulosND: any;
    graficaModulosNC: any;
    graficaModulosCB: any;
    graficaModulosRD: any;
    graficaModulosRR: any;
    graficaModulosP: any;
    graficaModulosR: any;
    graficaModulosG: any;
    rangeDates: Date[];
    logSeleccionado = new LogEmisor(null, "", "", "", "", "", "", "", "", "", "", [], "", "");

    locale = 'es';
    colorTheme = 'theme-dark-blue';
    bsConfig: Partial<BsDatepickerConfig>;

    constructor(private logsService: LogEmisorService,
                private route: ActivatedRoute,
                private router: Router,
                public jwtUtil: UtilConfig,
                private _localeService: BsLocaleService) {

        this._localeService.use(this.locale);
        this.bsConfig = Object.assign({}, {containerClass: this.colorTheme, showWeekNumbers: false});
        var fechaIni = (new Date().getMonth() + 1) + "/01/" + new Date().getFullYear();
        this.rangeDates = [new Date(), new Date()];

        this.emisor = jwtUtil.getCurrentUser().customer.id;
        // SI LA EMPRESA ES ESCON SE HABILITAN LOS SELECT
        if (this.emisor == jwtUtil.ESCON_CUSTOMER) {
            this.emisor = {label: 'Todos los contribuyentes', value: "-1"};
            this.empresaAdministradora = true;
        }
        this.emisores = [];
        this.emisores.push({label: 'Todos los contribuyentes', value: "-1"});
        this.consultarCombos();
        // VERIFICA LOS PERMISOS DEL LOG LOGEADO
        this.authorities = jwtUtil.verificarAuthorities(this.authorities);
        this.route.params.subscribe(params => {
            if (params['busqueda']) {
                this.emisor = params['busqueda'];
            }
        });

    }

    ngOnInit() {
        this.calcular();
    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴

    help() {
        $.getScript("./assets/layout/js/material-google.js", function () {
            setTimeout(function () {
                eval("$('#helpBusqueda').tapTarget('open');")
            }, 700);
            setTimeout(function () {
                eval("$('#helpBusqueda').tapTarget('close');")
            }, 5000);
        });
    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘


    public calcular() {
        this.getGraficaUnitarias();
        this.getGraficaGeneral();
    }

    consultarCombos() {
        // LLAMADO AL SERVICIO
        this.cargandoList = true;
        this.logsService.getCombos()
            .subscribe(result => {
                this.emisores = [];

                if (this.empresaAdministradora)
                    this.emisores.push({label: 'Todos los contribuyentes', value: "-1"});
                $.each(result.comboCustomers, (pos, item) => {
                    if (this.empresaAdministradora) {
                        this.emisores.push({label: item.value, value: item.key});
                    } else {
                        if (item.key == this.emisor) {
                            this.emisores.push({label: item.value, value: item.key});
                        }
                    }
                });
                this.cargandoList = false;
            }, err => {
                this.jwtUtil.manejoError(err, this.router);
            });
    }

    cambiarEmisor(em) {
        this.emisor = em;
        this.calcular();
    }

    private getGraficaGeneral() {
        // LLAMADO AL SERVICIO
        this.cargandoConsulta = true;
        this.logsService.dashboardGeneral(this.emisor.value, this.rangeDates)
            .subscribe(result => {
                if (result.codigo == 1) {
                    if (result.dashboard[0].key != null) {
                        this.graficaGeneral = result.dashboard;
                    }
                }
                this.cargandoConsulta = false;

            }, err => {
                this.graficaGeneral = null;
                this.cargandoConsulta = false;
                this.jwtUtil.manejoError(err, this.router);
            });
    }

    private getGraficaUnitarias() {
        // LLAMADO AL SERVICIO
        this.cargandoList = true;
        this.logsService.dashboardUnitarios(this.emisor.value, this.rangeDates, "INVOCE")
            .subscribe(result => {

                if (result.codigo == 1) {
                    $.each(result.detalles, (pos, item) => {
                        if ("FACTURA" == item.documento) {
                            this.graficaModulosFactura = [item.aceptadas, item.fallidas];
                        } else if ("BOLETA" == item.documento) {
                            this.graficaModulosBoleta = [item.aceptadas, item.fallidas];
                        } else if ("NOTA DE DÉBITO" == item.documento) {
                            this.graficaModulosND = [item.aceptadas, item.fallidas];
                        } else if ("NOTA DE CRÉDITO" == item.documento) {
                            this.graficaModulosNC = [item.aceptadas, item.fallidas];
                        } else if ("PERCEPCIÓN" == item.documento) {
                            this.graficaModulosP = [item.aceptadas, item.fallidas];
                        } else if ("RETENCIÓN" == item.documento) {
                            this.graficaModulosR = [item.aceptadas, item.fallidas];
                        } else if ("RESUMEN DIARIO" == item.documento) {
                            this.graficaModulosRD = [item.aceptadas, item.fallidas];
                        } else if ("GUIA DE REMISIÓN" == item.documento) {
                            this.graficaModulosG = [item.aceptadas, item.fallidas];
                        } else if ("COMUNICACIÓN DE BAJA" == item.documento) {
                            this.graficaModulosCB = [item.aceptadas, item.fallidas];
                        } else if ("RESUMEN DE REVERSIONES" == item.documento) {
                            this.graficaModulosRR = [item.aceptadas, item.fallidas];
                        }
                    });
                }

                this.cargandoList = false;
            }, err => {
                this.graficaModulosFactura = null;
                this.graficaModulosBoleta = null;
                this.graficaModulosND = null;
                this.graficaModulosNC = null;
                this.graficaModulosRD = null;
                this.graficaModulosRR = null;
                this.graficaModulosCB = null;
                this.graficaModulosP = null;
                this.graficaModulosP = null;
                this.graficaModulosG = null;
                this.cargandoList = false;
                this.jwtUtil.manejoError(err, this.router);
            });
    }
}





// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/reporte/dashboard/indicadores/indicadores.component.ts